import { useEffect, useState } from 'react';
import { Button, Input, DataTable, Column, Badge, IconButton, useToast, ConfirmDialog } from '../../../shared/components';
import { PlusIcon, TrashIcon } from '../../../shared/icons';
import { getSettingsRepository } from '../../../shared/services/settings/repositoryFactory';
import { ParamActivity } from '../../../shared/services/settings/types';

const repo = getSettingsRepository();

/**
 * Tabla de parametrizacion: Actividades. Permite agregar, modificar o desactivar
 * actividades sin cambios en el codigo fuente (Lista Inicial de Actividades, spec LCC).
 */
export function ActivitiesTab() {
  const toast = useToast();
  const [activities, setActivities] = useState<ParamActivity[]>([]);
  const [newName, setNewName] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [deleting, setDeleting] = useState<ParamActivity | null>(null);

  const load = () => repo.listActivities(true).then((a) => { setActivities(a); setIsLoading(false); });
  useEffect(() => { load(); }, []);

  const addActivity = async () => {
    if (!newName.trim()) return;
    await repo.createActivity(newName.trim());
    setNewName('');
    toast.show('Actividad agregada.');
    load();
  };

  const toggleActive = async (a: ParamActivity) => {
    await repo.updateActivity(a.id, { isActive: !a.isActive });
    load();
  };

  const columns: Column<ParamActivity>[] = [
    { key: 'name', header: 'Actividad', render: (a) => a.name, sortable: true, sortValue: (a) => a.sortOrder },
    {
      key: 'status',
      header: 'Estado',
      render: (a) => (
        <button onClick={() => toggleActive(a)}>
          <Badge tone={a.isActive ? 'success' : 'neutral'}>{a.isActive ? 'Activa' : 'Inactiva'}</Badge>
        </button>
      ),
    },
    {
      key: 'actions',
      header: '',
      render: (a) => (
        <IconButton icon={<TrashIcon width={16} height={16} />} label="Eliminar" onClick={() => setDeleting(a)} className="h-9 w-9 text-critical hover:bg-red-50" />
      ),
    },
  ];

  return (
    <div className="space-y-4">
      <div className="flex gap-3">
        <Input placeholder="Nombre de la actividad" value={newName} onChange={(e) => setNewName(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && addActivity()} />
        <Button size="md" leftIcon={<PlusIcon width={18} height={18} />} onClick={addActivity}>
          Agregar
        </Button>
      </div>
      <DataTable columns={columns} rows={activities} rowKey={(a) => a.id} isLoading={isLoading} emptyTitle="Sin actividades" />
      <ConfirmDialog
        open={!!deleting}
        title="Eliminar actividad"
        description={`¿Eliminar "${deleting?.name}"? Se recomienda desactivarla en vez de eliminarla si tiene registros históricos.`}
        tone="danger"
        confirmLabel="Eliminar"
        onCancel={() => setDeleting(null)}
        onConfirm={async () => {
          if (deleting) await repo.deleteActivity(deleting.id);
          setDeleting(null);
          load();
        }}
      />
    </div>
  );
}
